import { useMemo } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { useTheme } from '@/shared/ui';

import type { NavigationItemData } from '@/app/components/NavBar/components/NavigationItem';
import { useDashboard, DASHBOARD_NEW_SECTION_LABEL } from '@/features/dashboard';

export const useDashboardMenuItems = (): NavigationItemData[] => {
  const { data } = useDashboard();
  const theme = useTheme();

  return useMemo(() => {
    const dashboardItems =
      data && Object.keys(data).length > 0
        ? Object.keys(data).map(name => ({
            key: name,
            id: name,
            name,
            path: `/dashboard/${encodeURIComponent(name)}`
          }))
        : [];

    // Always add "Create Dashboard" button at the end
    return [
      ...dashboardItems,
      {
        key: 'new-dashboard',
        id: 'new-dashboard',
        name: DASHBOARD_NEW_SECTION_LABEL,
        path: '/dashboard/new',
        alignIconWithTopLevel: true,
        icon: (
          <AddIcon
            sx={{
              fontSize: 24
            }}
          />
        ),
        textSx: {
          color: theme.palette.gx.textDisabled
        }
      }
    ];
  }, [data, theme.palette.gx.textDisabled]);
};
